/**
 * @file src/pages/device-settings/components/StatusBadge.jsx
 * @description Status pill for device certificates (compliance / production).
 *
 * Pure presentational. Falls back to "inactive" styling for unknown statuses.
 *
 * Note: this is a different StatusBadge than the one in invoice-management-hub
 * — that one renders invoice statuses (DRAFT/ISSUED/etc), this one renders
 * cert statuses (active/pending/inactive/expired). They live in separate
 * folders intentionally.
 */

import React from "react";
import Icon from "components/AppIcon";

const STATUS_CONFIG = {
  active: {
    color: "text-green-700 bg-green-50 border-green-200",
    icon: "CheckCircle",
  },
  pending: {
    color: "text-yellow-700 bg-yellow-50 border-yellow-200",
    icon: "Clock",
  },
  inactive: {
    color: "text-red-700 bg-red-50 border-red-200",
    icon: "XCircle",
  },
  expired: {
    color: "text-gray-700 bg-gray-50 border-gray-200",
    icon: "AlertTriangle",
  },
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.inactive;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.color}`}
    >
      <Icon name={config.icon} size={12} className="mr-1" />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadge;
